var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"questions feedback"},[_vm._v(_vm._s(this.$t("default.questions")))]),_c('div',{staticClass:"link feedback",style:(_vm.link),on:{"click":_vm.openGithub}},[_vm._v(" "+_vm._s(this.$t("default.github"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }